import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form as FormikForm, Formik } from 'formik';
import { Button, Col, Container, Row } from 'react-bootstrap';
import API from '../../Helpers/API';
import ProfessionsService from '../../Helpers/ProfessionsService';
import { professionValidation } from '../../Helpers/ValidationSchemas/validation';
import ModalConfirm from '../ModalConfirm';
import AlertErrors from '../AlertErrors';
import TextInput from '../TextInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faPlus } from '@fortawesome/free-solid-svg-icons';
import BackLinkTitle from '../BackLinkTitle';
import Spinner from '../Spinner';
import { catchApiResponseError } from '../../Helpers/catchApiResponseError';

function AddProfession() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const resetMessages = () => {
    setShowErrors(false);
    setErrorMessages([]);
  };

  const handleSubmit = async (input) => {
    try {
      setShowSpinner(true);
      resetMessages();
      const response = await new ProfessionsService(new API()).addProfession({
        profession: input.profession,
      });

      if (response.status > 199 && response.status < 300) {
        sessionStorage.setItem('professionAdded', input.profession);
        navigate('/admin/professions');
      }
    } catch (err) {
      catchApiResponseError(err, setErrorMessages, setShowErrors);
      setShowSpinner(false);
    }
  };

  const handleClear = async (resetForm, validateForm) => {
    setErrorMessages([]);
    await resetForm();
    validateForm();
  };

  return (
    <>
      <Container>
        <div className="d-flex justify-content-center mb-5">
          <div className="mxw-400 w-100">
            <BackLinkTitle
              url="/admin/professions"
              srText="Back to professions"
              title="Add New Profession"
            />

            <AlertErrors show={showErrors} message={errorMessages} />

            <Formik
              enableReinitialize
              onSubmit={handleSubmit}
              initialValues={{
                profession: '',
              }}
              validationSchema={professionValidation}
              validateOnMount
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                validateForm,
                resetForm,
                touched,
                isValid,
                values,
                errors,
              }) => (
                <FormikForm onSubmit={handleSubmit}>
                  <TextInput
                    fieldName="profession"
                    label="Profession"
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    values={values}
                    touched={touched}
                    errors={errors}
                  />

                  <Row>
                    <Col xs="auto">
                      <Button
                        variant="primary"
                        disabled={!isValid || !values}
                        onClick={handleShow}
                      >
                        <FontAwesomeIcon icon={faPlus} className="me-2" />
                        Submit
                      </Button>
                    </Col>
                    <Col xs="auto">
                      <Button
                        variant="outline-secondary"
                        onClick={() => handleClear(resetForm, validateForm)}
                      >
                        <FontAwesomeIcon icon={faXmark} className="me-2" />
                        Clear
                      </Button>
                    </Col>
                  </Row>
                  <ModalConfirm
                    show={showModal}
                    title="Confirm"
                    text={`Are you sure you want to add ${values.profession} as a new profession?`}
                    confirmButtonText="Add Profession"
                    confirmClick={handleSubmit}
                    handleClose={handleClose}
                  />
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </Container>
      <Spinner show={showSpinner} />
    </>
  );
}
export default AddProfession;
